var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "15px",
    height: "20px",
    viewBox: "0 0 15 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 163.52,
    y1: 286.47,
    x2: 163.52,
    y2: 500.71,
    gradientTransform: "matrix(0.0389606,0,0,0.0368791,0.0195457,0.0700392)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(98.431373%,39.215686%,1.568627%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(94.901961%,74.509804%,6.27451%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(88.627451%,3.529412%,9.803922%)",
      fillOpacity: 1
    },
    d: "M 3.039062 8.496094 C 2.566406 4.488281 5.035156 1.671875 9.671875 0.0703125 C 6.832031 3.554688 12.089844 7.332031 12.378906 10.949219 C 13.058594 9.851562 13.445312 8.386719 13.519531 6.429688 C 16.996094 11.589844 14.117188 20.023438 6.46875 18.8125 C 5.765625 18.699219 5.089844 18.492188 4.472656 18.179688 C 1.683594 16.769531 0.0195312 13.699219 0.0195312 10.765625 C 0.0195312 8.894531 0.863281 7.226562 1.957031 5.898438 C 2.105469 7.199219 2.414062 8.167969 3.039062 8.496094 Z M 3.039062 8.496094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "url(#linear0)"
    },
    d: "M 5.441406 13.808594 C 4.589844 11.679688 4.707031 8.246094 7.089844 7.042969 C 7.105469 10.992188 11.125 11.492188 10.378906 15.707031 C 11.066406 14.953125 11.414062 13.75 11.476562 12.800781 C 12.566406 15.210938 11.710938 17.144531 10.15625 18.125 C 5.4375 21.113281 1.375 15.054688 4.074219 11.738281 C 4.15625 12.476562 5.09375 13.621094 5.441406 13.808594 Z M 5.441406 13.808594 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.88d99d6428a0fa0bdb3a40232608ae09.svg";
export { ForwardRef as ReactComponent };